// @flow
import React, { useEffect } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Input } from '@mzvonar/modular-redux-form';
import Field from '../../ui/form/Field';

const useStyles = makeStyles(theme => ({
    input: {
        marginLeft: theme.spacing(.5),
        marginRight: theme.spacing(.5),
        '& .MuiFormControl-marginDense': {
          margin: 0,
        },
        '& .MuiFilledInput-inputMarginDense': {
            padding: theme.spacing(1),
        }
    }
}));

export type Props = $ReadOnly<{
    index: number,
    name: string,
    point: [number, number],
    removable: boolean,

    inputChange: (name: string, value: mixed) => void,
    removePoint: (index: number) => void,
    onChange?: (index: number, point: [number, number]) => void
}>;

function Point({ index, name, point, removable, inputChange, removePoint, onChange }: Props) {
    const classes = useStyles();

    const xName = `${name}.lat`;
    const yName = `${name}.lon`;
    const x = point[0];
    const y = point[1];

    const remove = () => {
        removePoint(index);
    };

    useEffect(() => {
        inputChange(xName, x);
    }, [xName, x]);

    useEffect(() => {
        inputChange(yName, y);
    }, [yName, y]);

    const onXChange = (e) => {
        if(onChange) {
            let value = parseFloat(e.target.value);
            value = isNaN(value) ? undefined : value;

            if(point[0] !== value) {
                onChange(index, [value, point[1]]);
            }
        }
    };
    const onYChange = (e) => {
        if(onChange) {
            let value = parseFloat(e.target.value);
            value = isNaN(value) ? undefined : value;

            if(point[1] !== value) {
                onChange(index, [point[0], value]);
            }
        }
    };

    return (
        <TableRow>
            <TableCell size="small" padding="none" style={{ width: 1 }}>
                {index}
            </TableCell>
            <TableCell size="small" padding="none">
                <Input
                    className={classes.input}
                    name={xName}
                    component={Field}
                    validate={['required']}
                    onChange={onXChange}
                />
            </TableCell>
            <TableCell size="small" padding="none">
                <Input
                    className={classes.input}
                    name={yName}
                    component={Field}
                    validate={['required']}
                    onChange={onYChange}
                />
            </TableCell>
            <TableCell size="small" padding="none" align="right">
                <IconButton disabled={!removable} onClick={remove} aria-label="Delete point">
                    <CancelIcon/>
                </IconButton>
            </TableCell>
        </TableRow>
    );
}

export default Point